import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bb-product-items-page-ui',
    templateUrl: './bb-product-items-page-ui.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class ProductItemsPageComponent {}
